import { UIProfileController } from '../../../shared/scripts/profile/UIProfileController.ts';
import { HistoryTable, ProfilePageTabId, SearchPlayerInput } from '@colonist/clientforge';
import { UIProfileFriendsController } from '../../../shared/scripts/profile/UIProfileFriendsController.ts';
import { UIWProfileSettingsController } from './UIWProfileSettingsController.ts';
import { UIProfileRankedSeasonDropdownController } from '../../../shared/scripts/profile/UIProfileRankedSeasonDropdownController.ts';
import { LobbyImage } from '@colonist/types';
import { createImgIn, setElementInnerHTML } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { mountUIReactComponent } from '../../../shared/scripts/ui_platform/mountUIReactComponent.tsx';
import { UIAjaxWrapper } from '../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../../shared/scripts/network/UIAPIEndpoints.ts';
import { getProfileURI } from '../../../shared/scripts/ui_utils/TestableClientUtils.ts';
import { navigateToReplay, toHistoryGameViews } from '../../../shared/scripts/profile/historyUtils.ts';
import { UIViewProfilePopup } from '../../../shared/scripts/profile/UIViewProfilePopup.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { clientI18n } from '../../../shared/scripts/ClientI18n.ts';
import { UIProfileRankedController } from '../../../shared/scripts/profile/UIProfileRankedController.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
export class UIWProfileController extends UIProfileController {
    initControllers() {
        mountUIReactComponent('profile_search', SearchPlayerInput).render({
            searchOnClear: false,
            onSearch: (term)=>UIWProfileController.searchCallBack(term)
        });
        this.rankedController = new UIProfileRankedController(this.username);
        this.friendsController = new UIProfileFriendsController(this.username, this.profileLinkController, this.stickyPlayerTextContainer);
        this.settingsController = new UIWProfileSettingsController(this.getUsername(), this.profileLinkController);
    }
    static async searchCallBack(searchTerm) {
        if (searchTerm == '') return;
        const encodedSearchTerm = encodeURIComponent(searchTerm);
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.overview(encodedSearchTerm), undefined);
        if (response == undefined) return;
        const profileData = response.json;
        navigateToPage(getProfileURI(profileData.username));
    }
    onTabSelected(tabId) {
        super.onTabSelected(tabId);
        this.renderSearch();
    }
    // eslint-disable-next-line class-methods-use-this
    getUsername() {
        var _ClientUserState_userState;
        var _ClientUserState_userState_username;
        if (UIUtilsEjsVariables.isUserOnDiscord) return (_ClientUserState_userState_username = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username) !== null && _ClientUserState_userState_username !== void 0 ? _ClientUserState_userState_username : '';
        const path = window.location.pathname;
        const pathSegments = path.split('/');
        const usernamePathSegment = pathSegments[pathSegments.length - 1];
        return decodeURIComponent(usernamePathSegment);
    }
    refreshProfileForUsernameChange(newUsername) {
        super.refreshProfileForUsernameChange(newUsername);
        this.rankedController.username = newUsername;
        this.friendsController.setUsername(newUsername);
        document.title = clientI18n.t('strings:profilePage.pageHeadInfo.title', {
            username: newUsername,
            interpolation: {
                escapeValue: false
            }
        });
        if (!UIUtilsEjsVariables.isUserOnDiscord) {
            window.history.replaceState(null, document.title, getProfileURI(newUsername) + window.location.hash);
        }
    }
    setStickyUsername(username) {
        setElementInnerHTML(this.usernameHeader, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: username
            }
        });
    }
    setUserIcon(iconImage) {
        const lobbyImage = iconImage !== null && iconImage !== void 0 ? iconImage : LobbyImage.Guest;
        setElementInnerHTML(this.stickyPlayerInfoIcon, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        createImgIn(this.stickyPlayerInfoIcon, lobbyImage, 'profile-icon');
    }
    setMembershipIcon(membershipType) {
        const existingIcon = document.getElementById('sticky-player-membership-icon');
        if (existingIcon != undefined) existingIcon.remove();
        if (membershipType == undefined) return;
        const membershipIconLobbyImage = ColonistMembershipProduct.getMembershipProduct(membershipType).lobbyImage;
        createImgIn(this.stickyPlayerInfoIcon, membershipIconLobbyImage, 'profile-membership-icon', 'sticky-player-membership-icon');
    }
    accountDoesNotExist() {
        setElementInnerHTML(this.usernameHeader, {
            key: 'strings:commands.errors.userDoesNotExist'
        });
    }
    setHistory(historyData) {
        const { gameDatas, profileUserId } = historyData;
        const games = toHistoryGameViews(gameDatas, profileUserId, {
            isPopup: false
        });
        if (this.historyView == undefined) this.historyView = mountUIReactComponent('game-history-table', HistoryTable);
        this.historyView.render({
            games: games,
            profileUsername: decodeURIComponent(this.username),
            showReplayColumn: !UIUtilsEjsVariables.shouldHideStoreOnMobile,
            onReplayClick: navigateToReplay,
            onUsernameClick: (username)=>UIViewProfilePopup.init(username)
        });
    }
    setRankedSeasons(seasons) {
        new UIProfileRankedSeasonDropdownController(seasons, this.rankedController);
    }
    setProfileSettings(userLogins) {
        this.settingsController.setUserLoginState(userLogins);
    }
    renderSearch() {
        this.searchMount.hidden = !this.isSearchVisibleForActiveSection();
    }
    isSearchVisibleForActiveSection() {
        const activeTabId = this.profileLinkController.activeTabId;
        if (activeTabId == ProfilePageTabId.Overview) return true;
        if (activeTabId == ProfilePageTabId.Friends) return true;
        return false;
    }
    constructor(){
        super(), this.usernameHeader = document.getElementById('sticky_player_info_username'), this.stickyPlayerInfoIcon = document.getElementById('sticky_player_info_icon'), this.stickyPlayerTextContainer = document.getElementById('sticky_player_info_text_container'), this.searchMount = document.getElementById('profile_search');
        this.username = this.getUsername();
        this.profileLinkController.setUsername(this.username);
        document.title = clientI18n.t('strings:profilePage.pageHeadInfo.title', {
            username: this.username,
            interpolation: {
                escapeValue: false
            }
        });
        this.initControllers();
        this.init();
        this.renderSearch();
    }
}
